/**
 * jQuery version of https://jsfiddle.net/link2twenty/
 */

import $ from 'jquery';

export default new class Tabs {
  constructor() {
    this.keys = {
      SPACE: 32,
      RETURN: 13,
      ARROW_LEFT: 37,
      ARROW_RIGHT: 39,
    };
    this.selectors = {
      container: '.js-tabs-wrapper',
      list: '.js-tabs',
      tabs: '.js-tabs-tab',
      panels: '.js-tabs-panel',
      activeTab: '.js-tabs-tab[aria-selected=true]',
    };
    this.init();
  }

  init() {
    $(this.selectors.container).each((index, container) => {
      this.addEventListeners(container);
    });

    this.activateByHash();
  }

  activateByHash() {
    const hash = window.location.hash.substr(1);
    if (hash) {
      this.setActiveTab(hash);
    }
  }

  addEventListeners(container) {
    const $container = $(container);
    const $tabs = $container.find(this.selectors.tabs);
    $tabs.on('click', event => {
      event.preventDefault();
      const $tab = $(event.currentTarget);
      this.setActiveTab($tab.attr('aria-controls'));
    });

    $tabs.on('keyup', event => {
      if (
        event.keyCode === this.keys.SPACE ||
        event.keyCode === this.keys.RETURN
      ) {
        event.preventDefault();
        const $tab = $(event.currentTarget);
        this.setActiveTab($tab.attr('aria-controls'));
      }
    });

    $container.find(this.selectors.list).on('keyup', event => {
      const $activeTab = $container.find(this.selectors.activeTab);
      if (event.keyCode === this.keys.ARROW_LEFT) {
        event.preventDefault();
        const prev = $tabs.index($activeTab) - 1;
        const index = prev >= 0 ? prev : $tabs.length - 1;
        this.setActiveTab($tabs.eq(index).attr('aria-controls'));
      } else if (event.keyCode === this.keys.ARROW_RIGHT) {
        event.preventDefault();
        const next = $tabs.index($activeTab) + 1;
        const index = next < $tabs.length ? next : 0;
        this.setActiveTab($tabs.eq(index).attr('aria-controls'));
      }
    });
  }

  setActiveTab(id) {
    const $container = $(`#${id}`).parents(this.selectors.container);

    $container.find(this.selectors.tabs).each((index, tab) => {
      const $tab = $(tab);
      if ($tab.attr('aria-controls') === id) {
        $tab.attr('aria-selected', 'true');
        $tab.focus();
      } else {
        $tab.attr('aria-selected', 'false');
      }
    });

    $container.find(this.selectors.panels).each((index, panel) => {
      const $panel = $(panel);
      if ($panel.attr('id') === id) {
        $panel.attr('aria-expanded', 'true');
      } else {
        $panel.attr('aria-expanded', 'false');
      }
    });
    window.history.pushState(null, null, `#${id}`);
  }
}();



// WEBPACK FOOTER //
// ./src/scripts/modules/tabs.js